import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { Flex, Box, Link, Icon, useDisclosure, useBreakpointValue, Stack, Image } from "@chakra-ui/react"
import { FiX, FiMenu } from "react-icons/fi"
import Nav from "components/nav/nav"
import CrfStripe from "components/header/crfStripe"
import { useRouter } from "next/router"

export default function HeaderTct2025({ site, hideNav = false, onViewportChange }) {
    const { open, onToggle } = useDisclosure({ defaultIsOpen: false })
    const isMobile = useBreakpointValue({ base: true, xl: false }, { fallback: "menu" })
    const [menuIsTooWideForWindow, setMenuIsTooWideForWindow] = useState(false)
    const [isScrolled, setIsScrolled] = useState(false)
    const showMobileMenu = useMemo(() => {
        return isMobile || menuIsTooWideForWindow
    }, [isMobile, menuIsTooWideForWindow])
    const crfStripeHeight = useMemo(() => {
        return isMobile || site.theme.hideCrfTopBar ? 0 : 42
    }, [isMobile])
    const banner = useRef()

    const bannerHeight = 180 // desktop height
    const router = useRouter()

    useEffect(() => {
        if (open && showMobileMenu) {
            document.body.classList.add("menu-isOpen")
        } else {
            document.body.classList.remove("menu-isOpen")
        }
        onViewportChange && onViewportChange(showMobileMenu, showMobileMenu ? crfStripeHeight + "px" : "62px")
    }, [open, showMobileMenu])

    const onScroll = useCallback(event => {
        // const { pageYOffset, scrollY } = window
        const _bannerHeight = banner.current?.offsetHeight
        setIsScrolled(window.scrollY > _bannerHeight)
    }, [])

    useEffect(() => {
        window.addEventListener("scroll", onScroll)
        return () => {
            window.removeEventListener("scroll", onScroll)
        }
    }, [])

    return (
        <>
            {!isMobile && !site.theme.hideCrfTopBar && <CrfStripe />}
            <Box
                ref={banner}
                className="headerBanner"
                height={{ base: "unset", xl: bannerHeight + "px" }}
                py={{ base: "15px", xl: "20px" }}
                px="15px"
                w="100%"
                mt={{ base: 0, xl: `${crfStripeHeight}px` }}
                bgColor="#000"
                zIndex={1200}
                bgImage={
                    isMobile
                        ? `url(${site.theme.backgroundImageMobile[0]?.url})`
                        : `url(${site.theme.backgroundImage[0]?.url})`
                }
                bgSize="cover"
                bgRepeat="no-repeat"
                backgroundPosition={{ base: "bottom center", xl: "right top" }}
            >
                <Stack
                    direction={{ base: "column", xl: "row" }}
                    gap={4}
                    alignItems="center"
                    justifyContent="space-between"
                    maxW="1500px"
                    height="100%"
                    margin="0 auto"
                >
                    <Flex
                        alignItems="center"
                        justifyContent="left"
                        h="100%"
                        w={{ base: "100%", md: "500px" }}
                        className={"logoWrapper"}
                        px={{ base: 0, md: 0 }}
                        maxW="600px"
                        mt={{ base: 4, md: 0 }}
                        mb={{ base: 3, md: 0 }}
                        cursor={"pointer"}
                        onClick={() => {
                            router.push(site.meeting.homeUrl || "/")
                        }}
                    >
                        <Link href={site.meeting.homeUrl || "/"}>
                            <Image
                                className={"heroLogo"}
                                src={site.theme?.headerLockup[0]?.url}
                                alt={"meeting logo"}
                                width={"100%"}
                            />
                        </Link>
                    </Flex>
                    <Box className="headerContent" dangerouslySetInnerHTML={{ __html: site.theme.contentBlock }} />
                </Stack>
            </Box>
            <Flex
                className="menubar"
                position={isScrolled ? "fixed" : "relative"}
                top={{
                    base: isScrolled ? 0 : "unset",
                    md: isScrolled ? `${crfStripeHeight}px` : "unset",
                }}
                w="100%"
                maxW="100%"
                h="header.h"
                bg="#fff!important"
                zIndex={1200}
                boxShadow={isScrolled ? "0 2px 12px rgba(0,0,0,0.3)" : "none"}
                borderTop={isScrolled ? "1px solid #ccc" : "none"}
            >
                <Flex w="100%" h="100%" align="center" justifyContent="center">
                    <Flex
                        className="menu__menuBtn"
                        pr="15px"
                        display={showMobileMenu ? "flex" : "none"}
                        justifyContent="center"
                        alignItems="center"
                        h="100%"
                    >
                        <Icon
                            as={FiMenu}
                            color="#333"
                            cursor="pointer"
                            onClick={onToggle}
                            w="24px"
                            h="30px"
                            verticalAlign="-webkit-baseline-middle"
                        />
                    </Flex>
                    {!hideNav && (
                        <Box
                            className="menu"
                            display={showMobileMenu ? (open ? "block" : "none") : "block"}
                            position={showMobileMenu ? "fixed" : "relative"}
                            top={showMobileMenu ? 0 : "unset"}
                            left={showMobileMenu ? 0 : "unset"}
                            h={showMobileMenu ? "100vh" : "auto"}
                            w={showMobileMenu ? "100%" : "auto"}
                            pb={showMobileMenu ? "120px" : 0}
                            overflowY={showMobileMenu ? "scroll" : "unset"}
                            bg="color2"
                            zIndex="10"
                            margin="0 auto"
                        >
                            <Flex
                                className="menu__closeBtn"
                                justify="space-between"
                                // h={showMobileMenu ? "44px" : "62px" }
                                h={{ base: "44px", md: "62px" }}
                                alignItems="center"
                                display={showMobileMenu ? "flex" : "none"}
                            >
                                <Box pr="15px">
                                    <Icon
                                        as={FiX}
                                        color="#333"
                                        cursor="pointer"
                                        onClick={onToggle}
                                        w="24px"
                                        h="30px"
                                        verticalAlign="-webkit-baseline-middle"
                                    />
                                </Box>
                            </Flex>
                            <Nav
                                menu={site.menu}
                                sessionTypeTerm={site.meeting.sessionTypeTerm}
                                showMobileMenu={showMobileMenu}
                                mobileMenuToggle={onToggle}
                                setMenuIsTooWideForWindow={setMenuIsTooWideForWindow}
                            />
                        </Box>
                    )}
                </Flex>
            </Flex>
        </>
    )
}
